<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="cash-report-main-sidebar" position="left" lockedOpen="gt-md">
        <cash-report-main-sidebar></cash-report-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">

        <div class="content-card p-24" style="overflow-y: scroll;">
            <h1>{{'Cash report'|translate}} {{cashReport.number}}</h1>
            <h2>{{'Report date'|translate}} {{cashReport.createdAt|date: 'd.MM.y': 'UTC': locale}}</h2>
            <h3>{{'At checkout'|translate}}: {{cashReport.cash}}</h3>
            <br/>
            <div fxLayout="row">
                <div fxFlex="20"><b>{{'Opened at'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.createdAt|date: 'd.MM.y H:mm:ss': 'UTC': locale}}</div>
            </div>
            <div fxLayout="row">
                <div fxFlex="20"><b>{{'Opened by'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.createdBy.firstName}} {{cashReport.createdBy.lastName}} ({{cashReport.createdBy.username}})</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.closedAt">
                <div fxFlex="20"><b>{{'Closed at'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.closedAt|date: 'd.MM.y H:mm:ss': 'UTC': locale}}</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.closedBy">
                <div fxFlex="20"><b>{{'Closed by'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.closedBy.firstName}} {{cashReport.closedBy.lastName}} ({{cashReport.closedBy.username}})</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.startDayCash">
                <div fxFlex="20"><b>{{'Open day cash'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.startDayCash}}</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.endDayCash">
                <div fxFlex="20"><b>{{'End day cash'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.endDayCash}}</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.startDayComments">
                <div fxFlex="20"><b>{{'Start day comments'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.startDayComments}}</div>
            </div>
            <div fxLayout="row" *ngIf="cashReport.endDayComments">
                <div fxFlex="20"><b>{{'End day comments'|translate }}:</b></div>
                <div fxFlex="80">{{cashReport.endDayComments}}</div>
            </div>
            <br/>
            <table class="table">
                <thead>
                <th>{{'Proof'|translate}}</th>
                <th>{{'Description'|translate}}</th>
                <th>{{'Income'|translate}}</th>
                <th>{{'Outcome'|translate}}</th>
                <th>{{'Created at'|translate}}</th>
                <th>{{'Created by'|translate}}</th>
                <th>{{'Actions'|translate}}</th>
                </thead>
                <tbody>
                <tr *ngFor="let item of cashReport.items" [ngStyle]="{'color': item.deletedAt? 'red': 'black'}">
                    <td>{{item.proof}}</td>
                    <td>{{item.description}}</td>
                    <td class="text-center">{{item.income}}</td>
                    <td class="text-center">{{item.outcome}}</td>
                    <td class="text-center">{{item.createdAt|date: 'd.MM.y H:mm': 'UTC': locale}}</td>
                    <td>{{item.createdBy.firstName}} {{item.createdBy.lastName}} ({{item.createdBy.username}})</td>
                    <td>
                        <button
                                mat-button
                                class="mr-8"
                                aria-label="{{'Delete'|translate}}"
                                color="warn"
                                *ngIf="!item.deletedAt" (click)="showConfirmCashReportItemDeleteDialog(item)">
                            {{'Delete'|translate}}
                        </button>
                        <span *ngIf="item.deletedAt">
                            <b>{{'Deleted by'|translate}}</b>: {{item.deletedBy.firstName}} {{item.deletedBy.lastName}} ({{item.deletedBy.username}})<br/>
                            <b>{{'Deleted at'|translate}}</b>: {{item.deletedAt|date: 'd.MM.y H:mm': 'UTC': locale}}<br/>
                            <b>{{'Reason'|translate}}:</b> {{item.deleteReason}}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
